import { useAuthState } from '@raysee/hooks';
import firebase from 'firebase';
import { useRouter } from 'next/router';
import { Alert } from 'rsuite';

const Private: React.FC = ({ children }) => {
  const router = useRouter();
  const [user, loading, error] = useAuthState(firebase.auth());

  if (loading) {
    return <></>;
  }

  if (error) {
    Alert.error(error.message);
  }

  if (!user) {
    router.push('/login');
    return <></>;
  }

  return <>{children}</>;
};

export { Private };
